import React, { useEffect, useState, useContext } from "react";
import './News.css'
import logo from '../../Assest/LogoSingefin.png';
import NewsImages from '../../Assest/temporary/NewsImages.png';
import left from '../../Assest/left.png'
import right from '../../Assest/right.png'
import { urlApiServer, urlApiServerImage } from "../../Component/Config/Config";
import { NavLink } from "react-router-dom";
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";

function News() {

    const urlGetcoverNews = urlApiServer + "news?populate=*"
    const urlGetNews = urlApiServer + "postnews?populate=*"

    const [dataCoverNew, setDataCoverNew] = useState([]);
    const [dataNew, setDataNew] = useState([]);
    const [seeMore, setSeeMore] = useState()
    const [currentPage, setCurrentPage] = useState(0);
    const { infoUser } = useContext(LoginContext)

    const loggedInUser = () => {
        Swal.fire({
            title: "Error",
            text: "Ya estas vinculado",
            icon: "error",
            allowOutsideClick: false
        });
    }

    const newsPerPage = 5;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetcoverNews, requestOptions)
                    .then(response => response.json())
                    .then(coverNewsResponse => {
                        console.log('info de la portada de noticia: ', coverNewsResponse.data);
                        setDataCoverNew(coverNewsResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }
        })();
    }, [urlGetcoverNews]);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetNews, requestOptions)
                    .then(response => response.json())
                    .then(newsResponse => {
                        console.log('info de las noticia: ', newsResponse.data);
                        setDataNew(newsResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }

        })();
    }, [urlGetNews]);

    // Manejadores para la paginación
    const handleNextPage = () => {
        if (currentPage < Math.ceil(dataNew.length / newsPerPage) - 1) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    function handleNewsId(newsId) {
        console.log('newsId: ', newsId)
        setSeeMore((prevNewsId) => (prevNewsId === newsId ? null : newsId))
    }

    return (
        <div className="ContainerNewsSection">
            <div className="containerBannerNew">
                <div className="bannerNew">
                    <div
                        style={{
                            backgroundImage: dataCoverNew.length > 0 && dataCoverNew[0].imagen_portada_noticia?.url
                                ? `url(${urlApiServerImage}${dataCoverNew[0].imagen_portada_noticia.url})`
                                : "url('../../Assest/temporary/bannerNews.png')", // Imagen de respaldo
                            justifyContent: dataCoverNew.length > 0 && dataCoverNew[0].posicion_texto_banner === 'derecha'
                                ? 'flex-end'
                                : dataCoverNew.length > 0 && dataCoverNew[0].posicion_texto_banner === 'centro'
                                    ? 'center'
                                    : 'flex-start'
                        }}
                        className="imageBannerNew"
                    >
                        {dataCoverNew.length > 0 && dataCoverNew[0] ? (
                            <p className="titleBannerNew">
                                {dataCoverNew.length > 0 && dataCoverNew[0].titulo_portada_noticia ? dataCoverNew[0].titulo_portada_noticia : "..."}
                            </p>
                        ) : (
                            '...'
                        )}
                    </div>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                    {infoUser.isLoged === true ? (
                        <div className="ContainerButton">
                            <div className="ButtonBanner" onClick={loggedInUser}>
                                <p className="titleButtonBanner">VINCULATE</p>
                            </div>
                        </div>
                    ) : (
                        <div className="ContainerButton">
                            <NavLink className="navLinks navLinkLegal" to="/Vinculacion">
                                <div className="ButtonBanner">
                                    <p className="titleButtonBanner">VINCULATE</p>
                                </div>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div >
            <div className="containerInfoNewsNew">
                {dataCoverNew.length > 0 && dataCoverNew[0].texto_seccion_noticia ? (
                    dataCoverNew[0].texto_seccion_noticia.map((item, index) => {
                        if (item.type === "paragraph") {
                            return (
                                <>
                                    {item.children.map((child, i) => {
                                        // Si el texto tiene `bold: true`, lo envolvemos en un `<strong>`
                                        return child.bold ? (
                                            <p key={i} className="titleNewsSection">
                                                {child.text}
                                            </p>
                                        ) : (
                                            <p key={index} className="textNewsSection">
                                                {child.text}
                                            </p>
                                        );
                                    })}
                                </>
                            );
                        } else if (item.type === "list" && item.format === "unordered") {
                            return (
                                <ul key={index} className="textNewsSection">
                                    {item.children.map((listItem, i) => (
                                        <li key={i}>{listItem}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })
                ) : (
                    <p className="textNewsSection">...</p>
                )}
            </div>
            {
                dataNew.slice(currentPage * newsPerPage, (currentPage + 1) * newsPerPage).map((news, index) => (
                    <div
                        key={news.id || index}
                        className={`containerCommunicationsNews ${index % 2 === 0 ? "even" : "odd"}`}
                    >
                        {index % 2 === 0 ? (
                            <div className="containerCommunicationsNews1">
                                <div className="containerImageNewNews">
                                    <img
                                        src={news.imagen_noticia && news.imagen_noticia[0]?.url ? urlApiServerImage + news.imagen_noticia[0].url : NewsImages}
                                        alt="News"
                                        className="imageNewNews"
                                    />
                                </div>
                                <div className="containerInformationCommunicationsNews">
                                    <p className="titleNewsCommunicationsNews">{news.titulo_noticia}</p>
                                    {
                                        (
                                            seeMore === news.id
                                        )
                                            ?
                                            (
                                                <>
                                                    <p className="descriptionNewsComunicationNewsSeemore">{news.texto_noticia}</p>
                                                    <div className="buttonComunicationNews" onClick={() => handleNewsId(news.id)}>
                                                        <p className="textButtonComunicationNews">VER MENOS</p>
                                                    </div>
                                                </>
                                            )
                                            :
                                            (
                                                <>
                                                    <p className="descriptionNewsComunicationNews">{news.texto_noticia}</p>
                                                    <div className="buttonComunicationNews" onClick={() => handleNewsId(news.id)}>
                                                        <p className="textButtonComunicationNews">VER MAS</p>
                                                    </div>
                                                </>
                                            )
                                    }
                                </div>
                            </div>
                        ) : (
                            <div className="containerCommunicationsNews2">
                                <div className="containerInformationCommunicationsNews">
                                    <p className="titleNewsCommunicationsNews">{news.titulo_noticia}</p>
                                    {
                                        (
                                            seeMore === news.id
                                        )
                                            ?
                                            (
                                                <>
                                                    <p className="descriptionNewsComunicationNewsSeemore">{news.texto_noticia}</p>
                                                    <div className="buttonComunicationNews" onClick={() => handleNewsId(news.id)}>
                                                        <p className="textButtonComunicationNews">VER MENOS</p>
                                                    </div>
                                                </>
                                            )
                                            :
                                            (
                                                <>
                                                    <p className="descriptionNewsComunicationNews">{news.texto_noticia}</p>
                                                    <div className="buttonComunicationNews" onClick={() => handleNewsId(news.id)}>
                                                        <p className="textButtonComunicationNews">VER MAS</p>
                                                    </div>
                                                </>
                                            )
                                    }
                                </div>
                                <div className="containerImageNewNews">
                                    <img
                                        src={news.imagen_noticia && news.imagen_noticia[0]?.url ? urlApiServerImage + news.imagen_noticia[0].url : NewsImages}
                                        alt="News"
                                        className="imageNewNews"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                ))
            }
            {
                dataNew.length > newsPerPage && (
                    <div className="pagination">
                        <img
                            src={left}
                            alt="atras"
                            className="arrowLeft"
                            onClick={handlePrevPage}
                            style={{ cursor: currentPage > 0 ? "pointer" : "not-allowed", opacity: currentPage > 0 ? 1 : 0.5 }}
                        />
                        <img
                            src={right}
                            alt="adelante"
                            className="arrowRight"
                            onClick={handleNextPage}
                            style={{
                                cursor: currentPage < Math.ceil(dataNew.length / newsPerPage) - 1 ? "pointer" : "not-allowed",
                                opacity: currentPage < Math.ceil(dataNew.length / newsPerPage) - 1 ? 1 : 0.5,
                            }}
                        />
                    </div>
                )
            }
        </div >
    );

}

export default News;